/* luxury-wishlist.js */

const WISHLIST_KEY = 'naap_luxury_wishlist';

// Helper to get wishlist from localStorage
function getWishlist() {
  const data = localStorage.getItem(WISHLIST_KEY);
  return data ? JSON.parse(data) : [];
}

// Helper to save wishlist
function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

// Update UI state of heart buttons across the site
function updateWishlistButtons() {
  const items = getWishlist();
  const buttons = document.querySelectorAll('.custom-card__wishlist');
  
  buttons.forEach(btn => {
    const handle = btn.dataset.productHandle;
    const isWished = items.some(item => item.handle === handle);
    
    if (isWished) {
      btn.classList.add('is-active');
      // Fill heart if active
      btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
    } else {
      btn.classList.remove('is-active');
      // Empty heart if not active
      btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
    }
  });
}

// Handle clicking a wishlist button on a product card
function initWishlistButtons() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.custom-card__wishlist');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.productHandle;
    const title = btn.dataset.productTitle;
    const price = btn.dataset.productPrice;
    const image = btn.dataset.productImage;
    const url = btn.dataset.productUrl;

    let items = getWishlist();
    const existingIndex = items.findIndex(item => item.handle === handle);

    if (existingIndex > -1) {
      // Remove
      items.splice(existingIndex, 1);
    } else {
      // Add
      items.push({ handle, title, price, image, url });
    }

    saveWishlist(items);
    updateWishlistButtons();
    
    // If we are on the wishlist page, re-render
    if (window.location.pathname.includes('/pages/wishlist')) {
      renderWishlistPage();
    }
  });
}

// Render the wishlist page
function renderWishlistPage() {
  const grid = document.getElementById('WishlistGrid');
  const emptyState = document.getElementById('WishlistEmptyState');
  
  if (!grid || !emptyState) return;

  const items = getWishlist();

  if (items.length === 0) {
    grid.style.display = 'none';
    emptyState.style.display = 'block';
    return;
  }

  grid.style.display = 'grid';
  emptyState.style.display = 'none';
  grid.innerHTML = '';

  items.forEach(item => {
    // Construct HTML mimicking custom-card-product
    const cardHTML = `
      <div class="custom-card-wrapper wishlist-card">
        <button class="wishlist-card__remove" data-handle="${item.handle}" aria-label="Remove from wishlist">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="custom-card">
          <div class="custom-card__inner">
            <a href="${item.url}" class="custom-card__media">
              <div class="media media--transparent media--hover-effect">
                <img src="${item.image}" alt="${item.title}" loading="lazy" width="400" height="400">
              </div>
            </a>
          </div>
          <div class="custom-card__content">
            <h3 class="custom-card__title">
              <a href="${item.url}">${item.title}</a>
            </h3>
            <div class="custom-card__info">
              <div class="custom-card__price">
                <span class="price-item price-item--regular">${item.price}</span>
              </div>
            </div>
            <a href="${item.url}" class="button button--secondary custom-card__action" style="width:100%; border-radius:0; margin-top:1.5rem; border:1px solid currentColor;">View Product</a>
          </div>
        </div>
      </div>
    `;
    grid.insertAdjacentHTML('beforeend', cardHTML);
  });

  // Attach listeners to new remove buttons
  grid.querySelectorAll('.wishlist-card__remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const handle = btn.dataset.handle;
      let items = getWishlist();
      items = items.filter(i => i.handle !== handle);
      saveWishlist(items);
      renderWishlistPage();
    });
  });
}

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  updateWishlistButtons();
  
  if (window.location.pathname.includes('/pages/wishlist')) {
    renderWishlistPage();
  }
});
